import React, { useState, useEffect, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForgotPasswordMutation, useLoginMutation, useUpdatePasswordMutation } from "../../api/userSlice";
import { Button, Input, toastMessage } from "../utils";
import "./Login.css";
import LynkIdlogo from "../../Images/LynkID_Final.png";

import theme, { buttonClasses, textClasses } from "../utils/theme";
import { IconButton, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { valid_email, valid_password } from "../../services/validation";
import { setFavicon, setTitle } from "../../services/functions";
import { themeMode } from "../../services/hooks";

const S3_WHITE_LABEL_URL = "https://whitelabling.s3.ap-south-1.amazonaws.com";
const logoPath = "logo.png";
const logoMiniPath = "miniLogo.png";
const logoBgPath = "loginBg.png";

function useWhiteLabelAssets() {
	const [assets, setAssets] = useState({
		logo: "",
		mini_logo: "",
		login_bg: "",
		favicon: "",
		title: "",
	});

	useLayoutEffect(() => {
		const hostPath = window.location.host.split(".").slice(-2).join(".");
		let title = window.location.host.split(".").slice(-2)[0];
		const s3Url = `${S3_WHITE_LABEL_URL}/${hostPath}`;

		const isWhiteLabeling = !(hostPath.includes("lynkid") || hostPath.includes("localhost"));
		// console.log({ isWhiteLabeling });
		if (isWhiteLabeling) {
			setAssets((o) => ({ ...o, logo: `${s3Url}/${logoPath}`, login_bg: `${s3Url}/${logoBgPath}`, mini_logo: `${s3Url}/${logoMiniPath}`, title }));
			setFavicon(`${s3Url}/${logoMiniPath}`);
			setTitle(title);

			if (hostPath.includes("tektronixit")) {
				themeMode("lightMode", "#008f79");
			}
		}

		// fetch(`https://whitelabling.s3.ap-south-1.amazonaws.com/tektronixit.com/logo.png`).then(res=>{
		// 	console.log(res)
		// })
		// setAssets((o) => ({
		// 	...o,
		// 	logo: `${S3_WHITE_LABEL_URL}/tektronixit.com/logo.png`,
		// 	mini_logo: `${S3_WHITE_LABEL_URL}/tektronixit.com/miniLogo.png`,
		// 	login_bg: `${S3_WHITE_LABEL_URL}/tektronixit.com/loginBg.png`,
		// 	title,
		// }));
		// themeMode("lightMode", "#008f79");

		// setTimeout(() => {
		// 	const logoImg = document.querySelector(".login_wrap section.bg img");
		// 	const logoCanvas = document.querySelector(".login_wrap section.bg canvas");

		// 	logoImg.crossOrigin = "Anonymous";
		// 	logoImg.onload = () => {
		// 		const canvas = logoCanvas;
		// 		const ctx = canvas.getContext("2d");

		// 		canvas.width = img.width;
		// 		canvas.height = img.height;
		// 		ctx.drawImage(img, 0, 0, img.width, img.height);

		// 		// Get pixel data
		// 		const imageData = ctx.getImageData(0, 0, img.width, img.height);
		// 		const data = imageData.data;

		// 		let r = 0,
		// 			g = 0,
		// 			b = 0,
		// 			count = 0;

		// 		// Loop through pixels (skip some to improve performance)
		// 		for (let i = 0; i < data.length; i += 4 * 50) {
		// 			r += data[i]; // Red
		// 			g += data[i + 1]; // Green
		// 			b += data[i + 2]; // Blue
		// 			count++;
		// 		}

		// 		// Calculate average color
		// 		r = Math.floor(r / count);
		// 		g = Math.floor(g / count);
		// 		b = Math.floor(b / count);

		// 		console.log(`rgb(${r}, ${g}, ${b})`)
		// 	};
		// }, 100);
	}, []);

	return assets;
}

function Login() {
	useShowExpiredToast();
	const [isForgot, setIsForgot] = useState(false);
	const handleReset = () => {
		setIsForgot(false);
	};
	let url = localStorage.getItem("url");
	localStorage.clear();
	localStorage.setItem("url", url);

	const assets = useWhiteLabelAssets();

	return (
		<>
			<div className="login_wrap">
				<section className="bg" style={assets?.login_bg ? { background: `url(${assets?.login_bg}) no-repeat center center`, backgroundSize: "cover" } : {}}>
					<img src={assets?.logo || LynkIdlogo} alt="" className="" />
					<canvas className="logoCanvas" style={{ display: "none" }}></canvas>
				</section>
				<section>
					<div className="form_wrap">
						<div className="heading">
							{isForgot ? (
								<div style={{ display: "flex", alignItems: "center" }}>
									<IconButton onClick={handleReset}>
										<ArrowBack />
									</IconButton>
									<div style={{ flexBasis: "80%", display: "flex", alignItems: "center", justifyContent: "center" }}>Reset Password</div>
								</div>
							) : (
								<>
									<div>Get Started With</div>
									<div>
										<img src={assets?.logo || LynkIdlogo} alt="" className="" />
									</div>
								</>
							)}
						</div>
						{isForgot ? <ForgotPassword onClose={() => setIsForgot(false)} /> : <LoginForm onForgot={() => setIsForgot(true)} />}
					</div>
				</section>
			</div>
		</>
	);
}
export default Login;

function LoginForm({ onForgot }) {
	const [formData, setFormData] = useState({
		email: "",
		password: "",
	});
	const handleInput = (e) => {
		const { name, value } = e.target;
		setFormData((old) => ({ ...old, [name]: value }));
	};
	const navigate = useNavigate();
	const [passwordType, setPasswordType] = useState("password");
	const [handleLogin, { isLoading }] = useLoginMutation();
	const togglePassType = () => {
		if (passwordType == "password") {
			setPasswordType("text");
		} else {
			setPasswordType("password");
		}
	};

	const handleFormSubmit = async () => {
		const trimmedData = {
			email: formData.email.trim(),
			password: formData.password.trim(),
		};
		const {
			data: { error, message, token, permissions, email },
		} = await handleLogin(trimmedData);

		if (error) {
			toastMessage(false, message);
		} else {
			localStorage.setItem("secretkey", token);
			localStorage.setItem("userDetail", email);

			navigate("/loading");
		}
	};
	return (
		<form>
			<Input label="Email" type="email" id="email" placeholder="Enter your email" name="email" value={formData.email} onChange={handleInput} />
			<Input
				label="Password"
				id="password"
				name="password"
				placeholder="Enter your password"
				onChange={handleInput}
				type={passwordType}
				adornment={{
					is: true,
					onClick: togglePassType,
					type: passwordType === "password" ? "eye" : "eyeClose",
				}}
				value={formData.password}
				onKeyDown={(e) => {
					if (e.key == "Enter" && formData.email && formData.password) {
						handleFormSubmit();
					}
				}}
			/>

			<div>
				<span style={{ ...buttonClasses.small, margin: "0" }} onClick={onForgot}>
					Forgot Password?
				</span>
			</div>
			<Button
				text="Sign In"
				onClick={handleFormSubmit}
				style={{
					...buttonClasses.lynkitOrangeFill,
					borderRadius: "12px",
					boxShadow: "rgba(0, 0, 0, 0.25) 0px 4px 4px",
					height: "48px",
					fontWeight: "600",
					fontSize: "1rem",
					lineHeight: "22px",
					textTransform: "none",
				}}
				disabled={isLoading}
			/>
		</form>
	);
}

function useShowExpiredToast() {
	useEffect(() => {
		if (window.localStorage.getItem("isExpired")) {
			toastMessage(false, "Session Expired! Please login again...");
			window.localStorage.removeItem("isExpired");
		}
	}, []);
}
function ForgotPassword({ open, onClose }) {
	const [formData, setFormData] = useState({
		email: "",
		projectId: "LYNKID",
	});
	const [error, setError] = useState({});
	const [isOtpSent, setIsOtpSent] = useState(false);
	const [seconds, setSeconds] = useState(0);

	const handleInput = (e) => {
		const { name, value } = e.target;
		setFormData((old) => ({ ...old, [name]: value }));
	};
	const [handleForgotPass, { isLoading: isHandlingForgot }] = useForgotPasswordMutation();
	const [handleChangePass, { isLoading: isHandlingUpdate }] = useUpdatePasswordMutation();

	const handleFormSubmit = async (resend = false) => {
		let payload = {
			email: formData.email.trim(),
			projectId: "LYNKID",
		};

		if (isOtpSent) {
			payload = {
				...payload,
				otp: formData.otp,
				newPassword: formData.newPassword.trim(),
			};
		}

		const {
			data: { success, message },
		} = isOtpSent && !resend ? await handleChangePass(payload) : await handleForgotPass(payload);
		if (!success) {
			toastMessage(false, message);
		} else {
			toastMessage(true, message);
			if (!isOtpSent || resend) {
				setIsOtpSent(true);
				setSeconds(60);
			} else {
				handleClose();
			}
		}
	};
	const handleClose = () => {
		setFormData({});
		onClose();
	};

	const handleFormValidation = () => {
		let error = {};

		if (!isOtpSent) {
			if (!formData.email) error.email = "Email is required";
			else if (!valid_email(formData.email)) error.email = "Please enter a valid email";
		} else {
			if (!formData.otp) error.otp = "Please enter the OTP";
			if (!formData.newPassword) error.newPassword = "Password is required";
			else if (!valid_password(formData.newPassword))
				error.newPassword = "Password should contain minimum 8 characters, including at least 1 uppercase letter, 1 lowercase letter, 1 special character, and 1 number.";

			if (!formData.confirmPassword) error.confirmPassword = "Confirm new password";
			else if (formData.confirmPassword !== formData.newPassword) error.confirmPassword = "Passwords do not match";
		}

		if (Object.keys(error).length) {
			setError(error);
		} else {
			setError({});
			handleFormSubmit();
		}
	};

	const [passType, setPassType] = useState("password");
	const togglePassType = () => setPassType(passType == "password" ? "text" : "password");
	const [confPassType, setConfPassType] = useState("password");
	const toggleConfPassType = () => setConfPassType(confPassType == "password" ? "text" : "password");

	useEffect(() => {
		if (!isOtpSent) return;

		// console.log("interval usereffect");

		let interval = setInterval(() => {
			setSeconds((s) => {
				if (s == 0) {
					// console.log("reset to 0");
					clearInterval(interval);
					return 0;
				}
				return s - 1;
			});
		}, 1000);

		return () => clearInterval(interval);
	}, [isOtpSent]);

	return (
		<form className="form-inputs">
			{!isOtpSent ? <Input type="email" name="email" label="Email" placeholder="enter your email" value={formData.email} onChange={handleInput} error={error.email} required /> : null}

			{isOtpSent ? (
				<>
					<Input name="otp" label="OTP" placeholder="enter OTP" value={formData.otp || ""} onChange={handleInput} error={error.otp} required />
					<Input
						label="New Password"
						id="password"
						name="newPassword"
						placeholder="Enter new password"
						onChange={handleInput}
						type={passType}
						adornment={{
							is: true,
							onClick: togglePassType,
							type: passType === "password" ? "eye" : "eyeClose",
						}}
						value={formData.newPassword || ""}
						error={error.newPassword}
						required
					/>
					<Input
						label="Confirm Password"
						id="passwordConfirm"
						name="confirmPassword"
						placeholder="Confirm new password"
						onChange={handleInput}
						type={confPassType}
						adornment={{
							is: true,
							onClick: toggleConfPassType,
							type: confPassType === "password" ? "eye" : "eyeClose",
						}}
						value={formData.confirmPassword || ""}
						error={error.confirmPassword}
						required
					/>
					{seconds == 0 ? (
						<Button
							variant="text"
							style={{
								...textClasses.boldText,
								color: theme.themeOrange,
								textDecoration: "underline",
								cursor: "pointer",
								textTransform: "none",
							}}
							text="Resend OTP"
							onClick={() => handleFormSubmit(true)}
						/>
					) : (
						<Typography
							sx={{
								...textClasses.boldText,
								textTransform: "none",
							}}
						>
							Resend OTP in {seconds} seconds
						</Typography>
					)}{" "}
				</>
			) : null}

			<Button
				text={isOtpSent ? "Submit" : "Get OTP"}
				onClick={handleFormValidation}
				style={{
					...buttonClasses.lynkitOrangeFill,
					borderRadius: "12px",
					boxShadow: "rgba(0, 0, 0, 0.25) 0px 4px 4px",
					height: "48px",
					fontWeight: "600",
					fontSize: "1rem",
					lineHeight: "22px",
					textTransform: "none",
				}}
				disabled={isHandlingForgot || isHandlingUpdate}
			/>
		</form>
	);
}
